import React from "react";

import {
  Create,
  TextInput,
  SelectInput,
  SimpleForm,
  required,
  choices,
  useNotify,
  useRefresh,
  useRedirect,
} from "react-admin";

import { useCreateStyles } from "../__common/MyStyles";
import { MyCreateActions } from "../__common/MyCreateActions";
import { sleep } from "../../common/js/Functions";

export const ProvidersCreate = (props) => {
  const classes = useCreateStyles();

  const today = new Date();

  const validateRelation = choices(
    ["Friend/Family", "Customer", "Partner", "Other"],
    "Please choose one of the values"
  );

  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();

  const onSuccess = () => {
    notify(`Provider created`);
    sleep(2000).then(() => {
      redirect("/providers");
      refresh();
    });
  };

  return (
    <Create
      title="Create Provider"
      undoable={false}
      onSuccess={onSuccess}
      submitOnEnter={true}
      actions={<MyCreateActions />}
      classes={classes}
      {...props}
    >
      <SimpleForm defaultValue={{ updated_at: today }}>
        <TextInput
          label="Company Name"
          source="name"
          validate={required("Company name is required")}
        />
        <TextInput
          label="Reference Contact Name"
          source="contact_name"
          validate={required("Reference contact name is required")}
        />
        <TextInput
          label="Reference Contact Position"
          source="contact_position"
        />
        <SelectInput
          label="Relation"
          source="relation"
          choices={[
            { id: "Friend/Family", name: "Friend/Family" },
            { id: "Customer", name: "Customer" },
            { id: "Partner", name: "Partner" },
            { id: "Other", name: "Other" },
          ]}
          validate={validateRelation}
        />

        <TextInput label="Email Address" source="email" type="email" />

        <TextInput label="Phone Number" source="phone_number" />
      </SimpleForm>
    </Create>
  );
};
